import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import { Grid } from '@material-ui/core';

var FormControl =
/*#__PURE__*/
function (_Component) {
  _inherits(FormControl, _Component);

  function FormControl() {
    _classCallCheck(this, FormControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormControl).apply(this, arguments));
  }

  _createClass(FormControl, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          children = _props.children,
          other = _objectWithoutProperties(_props, ['onSubmit', 'children']);

      var childArray = React.Children.toArray(children);
      return React.createElement(Grid, {
        item: true,
        style: {
          width: '100%'
        }
      }, React.createElement(Grid, _extends({
        container: true
      }, other), React.Children.map(childArray, function (ch, idx) {
        // Check if any of the contained elements
        // are a submit button and add the onSubmit
        // function to it
        if (ch.props && ch.props.type === 'submit') {
          return React.cloneElement(ch, {
            onClick: onSubmit
          });
        }

        return ch;
      })));
    }
  }]);

  return FormControl;
}(Component);

export default FormControl;